import tmsService from "../services/tms.service";
import { parseDebriefsAndStudents } from "@/utils/tms.helper";

const state = () => ({
  debriefs: {},
  students: {},
  isLoading: false,
  currentDebrief: null,
});

const actions = {
  loadDebriefsForCurrentUser({ commit }) {
    commit("setIsLoading", true);

    return new Promise((resolve) => {
      tmsService
        .getDebriefs()
        .then((data) => {
          const { debriefs, students } = parseDebriefsAndStudents(data);

          commit("setDebriefs", debriefs);
          commit("setStudents", students);
        })
        .finally(() => {
          commit("setIsLoading", false);
          resolve();
        });
    });
  },
};

const mutations = {
  setDebriefs(state, newDebriefs) {
    state.debriefs = newDebriefs;
  },
  setCurrentDebrief(state, newDebrief) {
    state.currentDebrief = newDebrief;
  },
  setStudents(state, newStudents) {
    state.students = newStudents;
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
};

const getters = {
  isLoading: (state) => state.isLoading,
  debriefs: (state) => state.debriefs,
  currentDebrief: (state) => state.currentDebrief,
  students: (state) => state.students,
  numScenariosForStudent: (state) => (studentId) => {
    return Object.values(state.debriefs)
      .flat()
      .filter((d) => d.student && d.student.studentId === studentId)
      .length;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
